import React from "react";
import { connect } from "react-redux";
import { UPDATE_PERSONA } from "./query";
import { setPersonaList, getPersonaList } from "../../reducers";
import Form from "./form";

const EditPersonaAudience = (props: any) => {
    const { title, persona } = props;
    return (
        <div className="cmp-edit">
            <h5 className="cmp-edit__title">{title}</h5>
            <Form formType="update" formData={persona} query={UPDATE_PERSONA} />
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        personaAudience: getPersonaList(state),
        user: state.users.currentUser,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setPersonaList: (personaList: any) => {
            dispatch(setPersonaList(personaList));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPersonaAudience);
